import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES, JUDICIAL_DOCUMENT, OUTCOME_OF_TRIAL, PHASE_OF_CASE, TYPE_OF_JUDICIAL_DOCUMENT, TYPE_OF_COURT, DOCUMENT_TYPE, RESPONSIBLE_PARTNER, ORIGIN } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import { connect } from 'react-redux'
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config'
import { OApp } from '../../RootReducer/AppReducer'
import { TState } from '../../RootReducer/index';
import _ from 'lodash';
import SearchAdd from '../SearchAdd'
import FileUpload from '../FileUpload'
import { MENU_LIST_RESOURCE_FILE, METADATA_DATE_ACESSED, METADATA_DATE_PUBLISHED_LEGAL_TOOLS, METADATA_DATE_REFISTERED, METADATA_DISPLAY_AS, METADATA_DOCUMENT_TYPE, METADATA_METADATA_COLLECTED_BY, METADATA_METADATA_FINALISEDON, METADATA_NUMBER_OF_PAGE, METADATA_ORIGIN, METADATA_REAPONSIBLE_PARTNER, METADATA_URL } from '../../Features/Translations/translationKeys.ltd'
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations'

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
    appConstants: any
}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
    uploadFile: (file: any) => Promise<any>
    removeField: (key: string) => void
}



class ICCDocuments extends Component<IProps & WithTranslationProps> {

    handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
        const { name, value } = e.target;
        const { formData = {} } = this.props;
        if (this.props.setFormField) {
            if (name === "documentOrigin.source") {
                this.props.setFormField("documentOrigin", { ...formData['documentOrigin'], source: value })
            } else if (name === "documentOrigin.url") {
                this.props.setFormField("documentOrigin", { ...formData['documentOrigin'], url: value })
            } else {
                this.props.setFormField(e.target.name, e.target.value)
            }
        }
    }


    handleSuggestion = ({ name, value }) => {

    }

    onFileUpload = async (file) => {
        try {
            const res = await this.props.uploadFile(file);
            return res
        } catch (error) {
            throw error
        }
    }

    render() {
        const { classes, formData, appConstants, getTranslation } = this.props

        const FORM_CONFIG: IFormConfig[][] = [

            [
                { label: 'Date accessed/ downloaded', key: 'accessDate', type: 'date', onChange: this.handleChange, translationKey: METADATA_DATE_ACESSED },
                { label: 'Number of pages', key: 'numberOfPages', type: 'text', onChange: this.handleChange, translationKey: METADATA_NUMBER_OF_PAGE },
            ],

            [
                { label: 'Document type', key: 'documentType', type: 'select', translationKey: METADATA_DOCUMENT_TYPE, onChange: this.handleChange, options: _.get(appConstants, 'documentType') || DOCUMENT_TYPE },
                { label: 'Responsible partner', key: 'responsiblePartner', type: 'select', translationKey: METADATA_REAPONSIBLE_PARTNER, onChange: this.handleChange, options: _.get(appConstants, 'partner') || RESPONSIBLE_PARTNER },
            ],
            [
                { label: 'Metadata collected by', key: 'Metadata collected by', type: 'text', onChange: this.handleChange, translationKey: METADATA_METADATA_COLLECTED_BY },
                { label: 'Metadata finalised on', key: 'Metadata finalised on', type: 'date', onChange: this.handleChange, translationKey: METADATA_METADATA_FINALISEDON },
            ],
            [
                { label: 'Date published in the Legal Tools', key: 'publishDate', type: 'date', onChange: this.handleChange, translationKey: METADATA_DATE_PUBLISHED_LEGAL_TOOLS },
                { label: 'Date registered', key: 'registerDate', type: 'date', onChange: this.handleChange, translationKey: METADATA_DATE_REFISTERED },
            ],

            [
                {
                    label: 'Resource / File', key: 'Resource / File', type: 'component', onChange: this.handleChange, translationKey: MENU_LIST_RESOURCE_FILE, component: (
                        <FileUpload
                            accept="application/pdf"
                            formData={formData}
                            formKey="orignalPdfURL"
                            onUpload={this.onFileUpload}
                            label={getTranslation(MENU_LIST_RESOURCE_FILE) || "Resource / File Change"}
                            id="resource-file"
                        />
                    )
                }
            ],
            [
                { label: 'Display as', key: 'Display as', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_DISPLAY_AS }
            ],
            [
                { label: 'Origin', key: 'documentOrigin.source', type: 'select', translationKey: METADATA_ORIGIN, onChange: this.handleChange, options: _.get(appConstants, 'documentOrigin') || ORIGIN },
                { label: 'URL', key: "documentOrigin.url", type: 'text', onChange: this.handleChange, translationKey: METADATA_URL },
                // { label: 'URL', key: "documentOriginUrl", type: 'text', onChange: this.handleChange },
            ],

        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})


const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData']),
    appConstants: _.get(state.App, 'appConstants.LtdDoc')
});

const mapDispatchToProps = (dispatch): IDispatchProps => ({
    uploadFile: (file: any) => dispatch(ONewLTDDocument.uploadFile(file)),
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),
    removeField: (key: string) => dispatch(ONewLTDDocument.removeField(key)),
})


export default withStyles(STYLES)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(ICCDocuments)))